export function isPremiumEnabled(user) {
  if (user?.additional_roles?.length > 0) {
    return true;
  }

  return Boolean(
    user?.active_patron?.tier_title &&
      (user.active_patron.tier_title === "Fan" ||
        user.active_patron.tier_title === "Angel") &&
      user.active_patron.patron_status === "active_patron"
  );
}

export function getPremiumTier(user) {
  if (user?.additional_roles?.length > 0) {
    return user.additional_roles[0];
  }

  if (
    user?.active_patron?.tier_title &&
    user.active_patron.patron_status === "active_patron"
  ) {
    return user.active_patron.tier_title;
  }

  return undefined;
}
